import { TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ':hover': {
    background: '#74b2f0',
    cursor: 'pointer',
  }
}));